import React from 'react';

import PropTypes from 'prop-types';

import './TextView.css';

class TextView extends React.Component {
  shouldComponentUpdate(nextProps) {
    const {label, value, unit, minMode} = this.props;
    if (label !== nextProps.label) return true;
    if (value !== nextProps.value) return true;
    if (unit !== nextProps.unit) return true;
    if (minMode !== nextProps.minMode) return true;
    return false;
  }

  render() {
    const {label, value, unit, minMode} = this.props;
    let labelClass;
    let valueClass;

    if (minMode) {
      labelClass = 'col-md-7';
      valueClass = 'col-md-3 no-padding';
    } else {
      labelClass = 'col-xs-10 col-md-8';
      valueClass = 'col-xs-1 col-md-2';
    }
    return (
      <div className="middleAlign">
        <div className={labelClass}>
          <div className="row">
            <span className="spanStyleTextView">{label}</span>
          </div>
        </div>
        <div className={`valueWidth ${valueClass}`}>
          <span className="spanStyleTextView">{value}</span>
        </div>
        <div className="col-xs-2 col-md-2">
          <span className="spanStyleTextView">{unit}</span>
        </div>
      </div>
    );
  }
}

TextView.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  unit: PropTypes.string,
  minMode: PropTypes.bool,
};

TextView.defaultProps = {
  label: '',
  value: '',
  unit: '',
  minMode: false,
};

export default TextView;
